import React, { ReactNode } from 'react';

const escapeRegExp = (str: string): string => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const highlightMatchHelper = (text: string, query: string): ReactNode => {
  if (!query) return text;

  const safeQuery = escapeRegExp(query);
  const regex = new RegExp(`(${safeQuery})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark key={index} className="bg-[#CCF4D8] ">
        {part}
      </mark>
    ) : (
      part
    ),
  );
};
